import { ACCOUNT_SETTINGS_URL_V2 } from '../constants/main';
import { handleRedirect } from './utils';

export const ADDON = 'pro_plus';
export const SET_SUBSCRIPTION_END_DATE = 'SET_SUBSCRIPTION_END_DATE';

export const setSubscriptionEndDate = ({ subscriptionEndDate }) => ({
    type: SET_SUBSCRIPTION_END_DATE,
    payload: subscriptionEndDate,
});

export const planRedirect = () => (dispatch) =>
    dispatch(handleRedirect(ACCOUNT_SETTINGS_URL_V2));
